import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Blank_ScreenContext } from "../blank/blank-context";

declare let window: any;

export interface ITeklifOlustur_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ITeklifOlustur_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetLanguage: string;
  SetLanguage_dummy: string;
  GetKullanici: any[];
  GetKullanici_dummy: any[];
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  GetCariBilgileri: any[];
  GetCariBilgileri_dummy: any[];
  GetToplamTeklifSepeti: any[];
  GetToplamTeklifSepeti_dummy: any[];
  GetToplamSiparisSepetUrunSayisi: any[];
  GetToplamSiparisSepetUrunSayisi_dummy: any[];
  GetCariParaBirimi: any[];
  GetCariParaBirimi_dummy: any[];
  GetCariPlasiyerBilgileri: any[];
  GetCariPlasiyerBilgileri_dummy: any[];
  GetTeklifSepeti: any[];
  GetTeklifSepeti_dummy: any[];
  TeklifSepetHesapla: any[];
  TeklifSepetHesapla_dummy: any[];
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  GetTeklifSepetMarkalari: any[];
  GetTeklifSepetMarkalari_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  UpdateTeklifSepetiFiyat: number;
  UpdateTeklifSepetiFiyat_dummy: number;
  TeklifSepetUrunMiktarAzalt: number;
  TeklifSepetUrunMiktarAzalt_dummy: number;
  TeklifSepetUrunMiktarArtir: number;
  TeklifSepetUrunMiktarArtir_dummy: number;
  TeklifSepetiKalemSil: number;
  TeklifSepetiKalemSil_dummy: number;
  GetTeklifNumarasi: any[];
  GetTeklifNumarasi_dummy: any[];
  InsertTeklifMas: number;
  InsertTeklifMas_dummy: number;
  InsertTeklifTra: number;
  InsertTeklifTra_dummy: number;
  ForEach3: GetTeklifSepeti;
  ForEach3_dummy: GetTeklifSepeti;
  TeklifSonrasiSepetSil: number;
  TeklifSonrasiSepetSil_dummy: number;
  InsertTeklifGorusmeleri: number;
  InsertTeklifGorusmeleri_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  SendMail: boolean;
  SendMail_dummy: boolean;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp592680Visible: "visible" | "hidden";
  isComp433619Visible: "visible" | "hidden";
  isComp193109Visible: "visible" | "hidden";
  isComp643724Visible: "visible" | "hidden";
  isComp595843Visible: "visible" | "hidden";
  isComp660333Visible: "visible" | "hidden";
  isComp352571Visible: "visible" | "hidden";
  isComp128816Visible: "visible" | "hidden";
  isComp478517Visible: "visible" | "hidden";
  isComp687284Visible: "visible" | "hidden";
  isComp869934Visible: "visible" | "hidden";
  isComp350723Visible: "visible" | "hidden";
  isComp438927Visible: "visible" | "hidden";
  isComp325380Visible: "visible" | "hidden";
  isComp838301Visible: "visible" | "hidden";
  isComp25646Visible: "visible" | "hidden";
}

export class TeklifOlustur_ScreenBase extends React.PureComponent<
  ITeklifOlustur_ScreenProps,
  any
> {
  static contextType = Blank_ScreenContext;
  declare context: React.ContextType<typeof Blank_ScreenContext>;
  teklifolustur_711799_value_kuikaFlexGridRef: React.RefObject<any>;
  teklifolustur_669945_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 130715,
          PropertyName: "label",
          Value: "CALCULATE QUOTATION",
          TagName: "Button2_label",
        },
        {
          Id: 382541,
          PropertyName: "placeholder",
          Value:
            "VADEN NUMBER, OEM NUMBER, PRODUCT NUMBER, PRODUCT NAME, BRAND, MODEL, VEHICLE",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "SAVE QUOTATION",
          TagName: "Button1_label",
        },
        {
          Id: 25646,
          PropertyName: "label",
          Value: "SAVE QUOTATION",
          TagName: "Button3_label",
        },
        {
          Id: 395956,
          PropertyName: "label",
          Value: "PROFILE",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 711799,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORD TO VIEW",
          TagName: "FlexGrid1_nodatafoundmessage",
        },
        {
          Id: 669945,
          PropertyName: "nodatafoundmessage",
          Value: "NO RECORD TO VIEW",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 544028,
          PropertyName: "value",
          Value: "CART DETAILS",
          TagName: "Label43_value",
        },
        {
          Id: 655780,
          PropertyName: "placeholder",
          Value: "ENTER REQUEST NUMBER",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 451268,
          PropertyName: "placeholder",
          Value: "ENTER ORDER NUMBER",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 340892,
          PropertyName: "value",
          Value: "PAYMENT INFOS",
          TagName: "Label44_value",
        },
        {
          Id: 549498,
          PropertyName: "value",
          Value: "QUOTATION CART",
          TagName: "Label32_value",
        },
        {
          Id: 390566,
          PropertyName: "value",
          Value: "CHOOSE BRAND TO CREATE QUOTATION",
          TagName: "Label39_value",
        },
        {
          Id: 126774,
          PropertyName: "title",
          Value: "PICTURE",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 76949,
          PropertyName: "title",
          Value: "CODE",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 702212,
          PropertyName: "title",
          Value: "NAME",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 52543,
          PropertyName: "title",
          Value: "BRAND",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 734805,
          PropertyName: "title",
          Value: "AMOUNT",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 660333,
          PropertyName: "title",
          Value: "GROSS AMOUNT",
          TagName: "TableDefaultColumn1_title",
        },
        {
          Id: 352571,
          PropertyName: "title",
          Value: "GROSS AMOUNT",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 145328,
          PropertyName: "title",
          Value: "DISCOUNT RATE",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 971403,
          PropertyName: "title",
          Value: "NET PRICE",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 321128,
          PropertyName: "title",
          Value: "NET AMOUNT",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 509198,
          PropertyName: "title",
          Value: "ACCOUNT USER",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 588981,
          PropertyName: "title",
          Value: "OTHER",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 636561,
          PropertyName: "value",
          Value: "TOTAL AMOUNT",
          TagName: "Label19_value",
        },
        {
          Id: 987320,
          PropertyName: "value",
          Value: "DISCOUNT",
          TagName: "Label24_value",
        },
        {
          Id: 235303,
          PropertyName: "value",
          Value: "NET AMOUNT",
          TagName: "Label23_value",
        },
        {
          Id: 960022,
          PropertyName: "value",
          Value: "TAX",
          TagName: "Label22_value",
        },
        {
          Id: 452136,
          PropertyName: "value",
          Value: "GRAND TOTAL",
          TagName: "Label21_value",
        },
        {
          Id: 2567342,
          PropertyName: "a87d7f38-8bfa-3640-c6f8-d284846b4160_notify",
          Value:
            "QUOTATION SUCCESSFULLY CREATED. PLEASE CHECK FROM QUOTATION STATUS PAGE.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [
        {
          Id: 130715,
          PropertyName: "label",
          Value: "Calcular cotización",
          TagName: "Button2_label",
        },
        {
          Id: 382541,
          PropertyName: "placeholder",
          Value:
            "No. Vaden, No. oem, Nombre del producto, Marca, Modelo, Vehículo",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "Guardar cotización",
          TagName: "Button1_label",
        },
        {
          Id: 25646,
          PropertyName: "label",
          Value: "Guardar cotización",
          TagName: "Button3_label",
        },
        {
          Id: 669945,
          PropertyName: "nodatafoundmessage",
          Value: "No se encontraron registros para publicar",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 544028,
          PropertyName: "value",
          Value: "Información del carrito",
          TagName: "Label43_value",
        },
        {
          Id: 655780,
          PropertyName: "placeholder",
          Value: "Ingresar el No. de solicitud",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 451268,
          PropertyName: "placeholder",
          Value: "Ingresar notas a la cotización",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 340892,
          PropertyName: "value",
          Value: "Información del pago",
          TagName: "Label44_value",
        },
        {
          Id: 549498,
          PropertyName: "value",
          Value: "Cesta de cotización",
          TagName: "Label32_value",
        },
        {
          Id: 390566,
          PropertyName: "value",
          Value: "Crear una cotización seleccionando una marca",
          TagName: "Label39_value",
        },
        {
          Id: 126774,
          PropertyName: "title",
          Value: "Imagen",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 76949,
          PropertyName: "title",
          Value: "Código",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 702212,
          PropertyName: "title",
          Value: "Nombre",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 52543,
          PropertyName: "title",
          Value: "Marca",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 734805,
          PropertyName: "title",
          Value: "Cantidad",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 660333,
          PropertyName: "title",
          Value: "Precio",
          TagName: "TableDefaultColumn1_title",
        },
        {
          Id: 352571,
          PropertyName: "title",
          Value: "Precio",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 145328,
          PropertyName: "title",
          Value: "Tasa de descuento",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 971403,
          PropertyName: "title",
          Value: "Precio neto",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 321128,
          PropertyName: "title",
          Value: "Valor neto",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 509198,
          PropertyName: "title",
          Value: "Usuario",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 588981,
          PropertyName: "title",
          Value: "Otro",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 636561,
          PropertyName: "value",
          Value: "Valor total",
          TagName: "Label19_value",
        },
        {
          Id: 987320,
          PropertyName: "value",
          Value: "Descuento",
          TagName: "Label24_value",
        },
        {
          Id: 235303,
          PropertyName: "value",
          Value: "Valor neto",
          TagName: "Label23_value",
        },
        {
          Id: 960022,
          PropertyName: "value",
          Value: "IVA",
          TagName: "Label22_value",
        },
        {
          Id: 452136,
          PropertyName: "value",
          Value: "Total",
          TagName: "Label21_value",
        },
        {
          Id: 17381445,
          PropertyName: "a87d7f38-8bfa-3640-c6f8-d284846b4160_notify",
          Value:
            "Oferta creada correctamente. Puede consultar el progreso de la oferta en la página de estado de la oferta.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [
        {
          Id: 130715,
          PropertyName: "label",
          Value: "Calculer l'offre",
          TagName: "Button2_label",
        },
        {
          Id: 382541,
          PropertyName: "placeholder",
          Value: "no Vaden, no OEM, nom du produit, marque, modèle, véhicule",
          TagName: "TextInput3_placeholder",
        },
        {
          Id: 838301,
          PropertyName: "label",
          Value: "Enregistrer l'offre",
          TagName: "Button1_label",
        },
        {
          Id: 25646,
          PropertyName: "label",
          Value: "Enregistrer l'offre",
          TagName: "Button3_label",
        },
        {
          Id: 395956,
          PropertyName: "label",
          Value: "Profil",
          TagName: "ContentMenuItem4_5_label",
        },
        {
          Id: 669945,
          PropertyName: "nodatafoundmessage",
          Value: "Aucun enregistrement à afficher",
          TagName: "Table1_nodatafoundmessage",
        },
        {
          Id: 544028,
          PropertyName: "value",
          Value: "Informations sur le panier",
          TagName: "Label43_value",
        },
        {
          Id: 655780,
          PropertyName: "placeholder",
          Value: "Entrez le numéro de demande",
          TagName: "TextInput1_placeholder",
        },
        {
          Id: 451268,
          PropertyName: "placeholder",
          Value: "Entrez la note de l'offre",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 340892,
          PropertyName: "value",
          Value: "Informations de paiement",
          TagName: "Label44_value",
        },
        {
          Id: 549498,
          PropertyName: "value",
          Value: "Panier d'offres",
          TagName: "Label32_value",
        },
        {
          Id: 390566,
          PropertyName: "value",
          Value: "Vous pouvez créer une offre en sélectionnant une marque",
          TagName: "Label39_value",
        },
        {
          Id: 126774,
          PropertyName: "title",
          Value: "Image",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 76949,
          PropertyName: "title",
          Value: "Code",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 702212,
          PropertyName: "title",
          Value: "Nom",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 52543,
          PropertyName: "title",
          Value: "Marque",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 734805,
          PropertyName: "title",
          Value: "Quantité",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 660333,
          PropertyName: "title",
          Value: "Prix brut",
          TagName: "TableDefaultColumn1_title",
        },
        {
          Id: 352571,
          PropertyName: "title",
          Value: "Prix brut",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 145328,
          PropertyName: "title",
          Value: "Taux de remise",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 971403,
          PropertyName: "title",
          Value: "Prix net",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 321128,
          PropertyName: "title",
          Value: "Montant net",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 509198,
          PropertyName: "title",
          Value: "Utilisateur",
          TagName: "TableTemplateColumn11_title",
        },
        {
          Id: 588981,
          PropertyName: "title",
          Value: "Autre",
          TagName: "TableTemplateColumn0_title",
        },
        {
          Id: 636561,
          PropertyName: "value",
          Value: "Montant total",
          TagName: "Label19_value",
        },
        {
          Id: 987320,
          PropertyName: "value",
          Value: "Remise",
          TagName: "Label24_value",
        },
        {
          Id: 235303,
          PropertyName: "value",
          Value: "Montant net",
          TagName: "Label23_value",
        },
        {
          Id: 960022,
          PropertyName: "value",
          Value: "TVA",
          TagName: "Label22_value",
        },
        {
          Id: 452136,
          PropertyName: "value",
          Value: "Total général",
          TagName: "Label21_value",
        },
        {
          Id: 66374574,
          PropertyName: "a87d7f38-8bfa-3640-c6f8-d284846b4160_notify",
          Value:
            "L'offre a été créée avec succès. Vous pouvez contrôler le processus d'offre à partir de la page Statuts des offres.",
          TagName: "Notify_notify",
          IsNotify: true,
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "8a08ffb5-eec4-4862-b014-6c89166b8346",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 382541,
          PropertyName: "placeholder",
          Value: "vaden no,  oem no,  ürün ismi,  marka,  model, araç",
        },
        { Id: 136061, PropertyName: "label", Value: "Turkish" },
        { Id: 336272, PropertyName: "label", Value: "English" },
        { Id: 231293, PropertyName: "label", Value: "Spanish" },
        { Id: 410756, PropertyName: "label", Value: "French" },
        { Id: 395956, PropertyName: "label", Value: "Profil" },
        { Id: 549498, PropertyName: "value", Value: "Teklif Sepeti" },
        {
          Id: 390566,
          PropertyName: "value",
          Value: "Marka Seçerek Teklif Oluşturabilirsiniz",
        },
        {
          Id: 711799,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        {
          Id: 963109,
          PropertyName: "value",
          Value: "[datafield:musterimarka]",
        },
        { Id: 595843, PropertyName: "placeholder", Value: "Type here..." },
        {
          Id: 669945,
          PropertyName: "nodatafoundmessage",
          Value: "Listelenecek Kayıt Bulunamadı",
        },
        { Id: 126774, PropertyName: "title", Value: "Resim" },
        { Id: 76949, PropertyName: "title", Value: "Kod" },
        { Id: 992982, PropertyName: "value", Value: "[datafield:stokkodu]" },
        { Id: 702212, PropertyName: "title", Value: "Adı" },
        { Id: 252345, PropertyName: "value", Value: "[datafield:stokadi]" },
        { Id: 52543, PropertyName: "title", Value: "Marka" },
        {
          Id: 876682,
          PropertyName: "value",
          Value: "[datafield:musterimarka]",
        },
        { Id: 734805, PropertyName: "title", Value: "Miktar" },
        { Id: 439702, PropertyName: "placeholder", Value: "15" },
        { Id: 660333, PropertyName: "title", Value: "Burut Fiyat" },
        { Id: 240999, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 250332, PropertyName: "placeholder", Value: "15" },
        { Id: 352571, PropertyName: "title", Value: "Brut Fiyat" },
        { Id: 478517, PropertyName: "value", Value: "[datafield:birimfiyat]" },
        { Id: 145328, PropertyName: "title", Value: "İskonto Oranı" },
        {
          Id: 623962,
          PropertyName: "value",
          Value: "[datafield:iskontooranlari]",
        },
        { Id: 971403, PropertyName: "title", Value: "Net Fiyat" },
        { Id: 627044, PropertyName: "value", Value: "[datafield:netfiyat]" },
        { Id: 321128, PropertyName: "title", Value: "Net Tutar" },
        { Id: 289931, PropertyName: "value", Value: "[datafield:nettutar]" },
        { Id: 509198, PropertyName: "title", Value: "Kullanıcı" },
        { Id: 449349, PropertyName: "value", Value: "[datafield:adsoyad]" },
        { Id: 52346, PropertyName: "value", Value: "/" },
        { Id: 687284, PropertyName: "value", Value: "K" },
        { Id: 869934, PropertyName: "value", Value: "P" },
        { Id: 588981, PropertyName: "title", Value: "Diğer" },
        { Id: 130715, PropertyName: "label", Value: "Teklif Hesapla" },
        { Id: 544028, PropertyName: "value", Value: "Sepet Bilgileri" },
        { Id: 655780, PropertyName: "placeholder", Value: "Talep No Giriniz" },
        {
          Id: 451268,
          PropertyName: "placeholder",
          Value: "Teklif Notu Giriniz",
        },
        { Id: 340892, PropertyName: "value", Value: "Ödeme Bilgileri" },
        { Id: 636561, PropertyName: "value", Value: "Toplam Tutar" },
        { Id: 987320, PropertyName: "value", Value: "İskonto" },
        { Id: 235303, PropertyName: "value", Value: "Net Tutar" },
        { Id: 960022, PropertyName: "value", Value: "Kdv" },
        { Id: 452136, PropertyName: "value", Value: "Genel Toplam" },
        { Id: 838301, PropertyName: "label", Value: "Teklif Kaydet" },
        { Id: 25646, PropertyName: "label", Value: "Teklif Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach3: any[];

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.teklifolustur_382541_value_kuikaTextInputRef = React.createRef();
    this.teklifolustur_711799_value_kuikaFlexGridRef = React.createRef();
    this.teklifolustur_595843_value_kuikaTextInputRef = React.createRef();
    this.teklifolustur_669945_value_kuikaTableRef = React.createRef();
    this.teklifolustur_655780_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      SetLanguage: "",
      GetKullanici: [],
      ReadFromSessionStorage: "",
      GetCariBilgileri: [],
      GetToplamTeklifSepeti: [],
      GetToplamSiparisSepetUrunSayisi: [],
      GetCariParaBirimi: [],
      GetCariPlasiyerBilgileri: [],
      GetTeklifSepeti: [],
      TeklifSepetHesapla: [],
      TriggerEvent: "",
      GetTeklifSepetMarkalari: [],
      SetValueOf: "",
      ChangeVisibilityOf: "",
      UpdateTeklifSepetiFiyat: 0,
      TeklifSepetUrunMiktarAzalt: 0,
      TeklifSepetUrunMiktarArtir: 0,
      TeklifSepetiKalemSil: 0,
      GetTeklifNumarasi: [],
      InsertTeklifMas: 0,
      ForEach: false,
      TeklifSonrasiSepetSil: 0,
      InsertTeklifGorusmeleri: 0,
      Notify: false,
      IfThenElse: false,
      isComp592680Visible: "hidden",
      isComp433619Visible: "hidden",
      isComp193109Visible: "hidden",
      isComp643724Visible: "hidden",
      isComp595843Visible: "hidden",
      isComp660333Visible: "hidden",
      isComp352571Visible: "hidden",
      isComp128816Visible: "hidden",
      isComp478517Visible: "hidden",
      isComp687284Visible: "hidden",
      isComp869934Visible: "hidden",
      isComp350723Visible: "hidden",
      isComp438927Visible: "hidden",
      isComp325380Visible: "hidden",
      isComp838301Visible: "hidden",
      isComp25646Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "teklifolustur",
        "blank_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.TeklifOlusturPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.TeklifOlusturPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("teklifolustur", "blank_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("teklifolustur", "blank_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.TeklifOlusturPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.TeklifOlusturPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  TeklifOlusturPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      currentUsername_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetKullanici = result?.data.getKullanici;
    formVars.teklifolustur_280562_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );
    stateVars.isComp660333Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp352571Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp128816Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp478517Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("CariKod", "string")
      );
    stateVars.isComp838301Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(this, stateVars.ReadFromSessionStorage),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp25646Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, stateVars.ReadFromSessionStorage),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeklifOlusturPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      isPlasiyer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      PlasiyerCariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      CariKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      FirmaKodu_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      paraBirimi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      SessionCariKod_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        "string"
      ),
      gykPlasiyerKodu_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].plasiyerKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].plasiyerKodu
            : null
        ),
        "string"
      ),
      CariPlasiyerKodu_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].plasiyeR_KODU
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].plasiyeR_KODU
            : null
        ),
        "string"
      ),
      kulID_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      CariKod_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      MusteriMarka_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_595843_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KullaniciID_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      CariKodu_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      MusteriMarka_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_595843_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCariBilgileri = result?.data.getCariBilgileri;
    stateVars.GetToplamTeklifSepeti = result?.data.getToplamTeklifSepeti;
    formVars.teklifolustur_307216_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );
    stateVars.GetToplamSiparisSepetUrunSayisi =
      result?.data.getToplamSiparisSepetUrunSayisi;
    formVars.teklifolustur_207799_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );
    stateVars.GetCariParaBirimi = result?.data.getCariParaBirimi;
    formVars.teklifolustur_471642_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.teklifolustur_120874_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.teklifolustur_72690_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.teklifolustur_896663_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    formVars.teklifolustur_52582_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );
    stateVars.GetCariPlasiyerBilgileri = result?.data.getCariPlasiyerBilgileri;
    stateVars.GetTeklifSepeti = result?.data.getTeklifSepeti;

    stateVars.isComp438927Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeklifSepeti !== undefined
            ? stateVars.GetTeklifSepeti?.length > 0
              ? stateVars.GetTeklifSepeti[0].id
              : null
            : this.state.GetTeklifSepeti?.length > 0
            ? this.state.GetTeklifSepeti[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.TeklifSepetHesapla = result?.data.teklifSepetHesapla;
    formVars.teklifolustur_726378_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].toplamTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].toplamTutar
        : null
    );
    formVars.teklifolustur_970782_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].toplamIskontoTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].toplamIskontoTutar
        : null
    );
    formVars.teklifolustur_366791_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].netTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].netTutar
        : null
    );
    formVars.teklifolustur_349593_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].kdvTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].kdvTutar
        : null
    );
    formVars.teklifolustur_961953_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].genelToplam
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].genelToplam
        : null
    );
    stateVars.isComp325380Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.TeklifSepetHesapla !== undefined
            ? stateVars.TeklifSepetHesapla?.length > 0
              ? stateVars.TeklifSepetHesapla[0].kdvTutar
              : null
            : this.state.TeklifSepetHesapla?.length > 0
            ? this.state.TeklifSepetHesapla[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.TeklifOlusturComponent_130715_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturPageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeklifOlusturPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      secilenMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_595843_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturPageInit4_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTeklifSepetMarkalari = result?.data.getTeklifSepetMarkalari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturPageInit5_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.teklifolustur_307216_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamTeklifSepeti !== undefined
        ? stateVars.GetToplamTeklifSepeti?.length > 0
          ? stateVars.GetToplamTeklifSepeti[0].toplamTeklifSepeti
          : null
        : this.state.GetToplamTeklifSepeti?.length > 0
        ? this.state.GetToplamTeklifSepeti[0].toplamTeklifSepeti
        : null
    );

    formVars.teklifolustur_207799_count = ReactSystemFunctions.toString(
      this,
      stateVars.GetToplamSiparisSepetUrunSayisi !== undefined
        ? stateVars.GetToplamSiparisSepetUrunSayisi?.length > 0
          ? stateVars.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
          : null
        : this.state.GetToplamSiparisSepetUrunSayisi?.length > 0
        ? this.state.GetToplamSiparisSepetUrunSayisi[0].toplamSiparisSepeti
        : null
    );

    formVars.teklifolustur_280562_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetKullanici !== undefined
        ? stateVars.GetKullanici?.length > 0
          ? stateVars.GetKullanici[0].adSoyad
          : null
        : this.state.GetKullanici?.length > 0
        ? this.state.GetKullanici[0].adSoyad
        : null
    );

    formVars.teklifolustur_336678_label = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariBilgileri !== undefined
        ? stateVars.GetCariBilgileri?.length > 0
          ? stateVars.GetCariBilgileri[0].carI_ISIM
          : null
        : this.state.GetCariBilgileri?.length > 0
        ? this.state.GetCariBilgileri[0].carI_ISIM
        : null
    );

    stateVars.dataSource_711799 =
      stateVars.GetTeklifSepetMarkalari ?? this.state.GetTeklifSepetMarkalari;
    stateVars.isComp433619Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "teklifolustur_711799_value",
          "isaktif"
        ),
        ReactSystemFunctions.convertToTypeByName("true", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp193109Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "teklifolustur_711799_value",
          "isaktif"
        ),
        ReactSystemFunctions.convertToTypeByName("false", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_669945 =
      stateVars.GetTeklifSepeti ?? this.state.GetTeklifSepeti;
    stateVars.isComp660333Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp352571Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.teklifolustur_128816_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp128816Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp478517Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.teklifolustur_136364_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.teklifolustur_331643_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    stateVars.isComp687284Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "teklifolustur_669945_value",
          "plasiyerMi"
        ),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp869934Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "teklifolustur_669945_value",
          "plasiyerMi"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp438927Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetTeklifSepeti !== undefined
            ? stateVars.GetTeklifSepeti?.length > 0
              ? stateVars.GetTeklifSepeti[0].id
              : null
            : this.state.GetTeklifSepeti?.length > 0
            ? this.state.GetTeklifSepeti[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.teklifolustur_471642_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.teklifolustur_726378_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].toplamTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].toplamTutar
        : null
    );

    formVars.teklifolustur_120874_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.teklifolustur_970782_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].toplamIskontoTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].toplamIskontoTutar
        : null
    );

    formVars.teklifolustur_72690_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.teklifolustur_366791_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].netTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].netTutar
        : null
    );

    stateVars.isComp325380Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.TeklifSepetHesapla !== undefined
            ? stateVars.TeklifSepetHesapla?.length > 0
              ? stateVars.TeklifSepetHesapla[0].kdvTutar
              : null
            : this.state.TeklifSepetHesapla?.length > 0
            ? this.state.TeklifSepetHesapla[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.teklifolustur_896663_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.teklifolustur_349593_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].kdvTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].kdvTutar
        : null
    );

    formVars.teklifolustur_52582_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCariParaBirimi !== undefined
        ? stateVars.GetCariParaBirimi?.length > 0
          ? stateVars.GetCariParaBirimi[0].paraSembol
          : null
        : this.state.GetCariParaBirimi?.length > 0
        ? this.state.GetCariParaBirimi[0].paraSembol
        : null
    );

    formVars.teklifolustur_961953_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].genelToplam
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].genelToplam
        : null
    );

    stateVars.isComp838301Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp25646Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  TeklifOlusturComponent_382541_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/arama") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Arama",
      "Ara",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_382541_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifOlustur",
      "Arama",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_204813_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifolustur") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifOlustur",
      "TeklifOlustur",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_918102_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "FirmaKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SiparisSepetOzet",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifOlustur",
      "SiparisSepetOzet",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "288727",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_136061_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("tr_TR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_336272_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("en_US", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_231293_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("es_ES", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_410756_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetLanguage = await ReactSystemFunctions.setLanguage(
      this,
      ReactSystemFunctions.convertToTypeByName("fr_FR", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_395956_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/profil") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifOlustur",
      "Profil",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_999177_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "teklifolustur_595843_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        "teklifolustur_711799_value",
        "musteriMarka"
      ),
      null,
      null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_999177_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeklifOlusturComponent_999177_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      secilenMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_595843_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_999177_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTeklifSepetMarkalari = result?.data.getTeklifSepetMarkalari;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_999177_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturComponent_999177_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp592680Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    await this.TeklifOlusturPageInit();

    if (await this.TeklifOlusturComponent_130715_onClick()) return true;

    stateVars.dataSource_711799 =
      stateVars.GetTeklifSepetMarkalari ?? this.state.GetTeklifSepetMarkalari;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_669945_onRowEditFinished = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "Table_669945_birimFiyat",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifolustur_669945_value", ".id"),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_669945_onRowEditFinished",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateTeklifSepetiFiyat = result?.data.updateTeklifSepetiFiyat;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.TeklifOlusturComponent_669945_onRowEditFinished1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturComponent_669945_onRowEditFinished1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.TeklifOlusturPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_782354_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Resimler",
      "StokKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "teklifolustur_669945_value",
          "stokKodu"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifOlustur",
      "Resimler",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "986362",
      null,
      null,
      "true",
      "600px",
      "600px",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_759465_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifolustur_669945_value", "id"),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_759465_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetUrunMiktarAzalt =
      result?.data.teklifSepetUrunMiktarAzalt;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_759465_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturComponent_759465_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.TeklifOlusturPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_887177_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifolustur_669945_value", "id"),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_887177_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetUrunMiktarArtir =
      result?.data.teklifSepetUrunMiktarArtir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_887177_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturComponent_887177_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.TeklifOlusturPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_307628_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "teklifolustur_669945_value", "id"),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_307628_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetiKalemSil = result?.data.teklifSepetiKalemSil;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_307628_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturComponent_307628_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.TeklifOlusturPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_130715_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KullaniciID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      CariKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].musteriKodu
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].musteriKodu
            : null
        ),
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_595843_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_130715_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSepetHesapla = result?.data.teklifSepetHesapla;
    formVars.teklifolustur_726378_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].toplamTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].toplamTutar
        : null
    );
    formVars.teklifolustur_970782_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].toplamIskontoTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].toplamIskontoTutar
        : null
    );
    formVars.teklifolustur_366791_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].netTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].netTutar
        : null
    );
    formVars.teklifolustur_349593_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].kdvTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].kdvTutar
        : null
    );
    formVars.teklifolustur_961953_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].genelToplam
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].genelToplam
        : null
    );
    stateVars.isComp325380Visible =
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.TeklifSepetHesapla !== undefined
            ? stateVars.TeklifSepetHesapla?.length > 0
              ? stateVars.TeklifSepetHesapla[0].kdvTutar
              : null
            : this.state.TeklifSepetHesapla?.length > 0
            ? this.state.TeklifSepetHesapla[0].kdvTutar
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_130715_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturComponent_130715_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.teklifolustur_726378_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].toplamTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].toplamTutar
        : null
    );

    formVars.teklifolustur_970782_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].toplamIskontoTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].toplamIskontoTutar
        : null
    );

    formVars.teklifolustur_366791_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].netTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].netTutar
        : null
    );

    formVars.teklifolustur_349593_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].kdvTutar
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].kdvTutar
        : null
    );

    formVars.teklifolustur_961953_value = ReactSystemFunctions.toString(
      this,
      stateVars.TeklifSepetHesapla !== undefined
        ? stateVars.TeklifSepetHesapla?.length > 0
          ? stateVars.TeklifSepetHesapla[0].genelToplam
          : null
        : this.state.TeklifSepetHesapla?.length > 0
        ? this.state.TeklifSepetHesapla[0].genelToplam
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_838301_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      isPlasiyer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "number"
      ),
      FirmaKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      GenelToplam_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.TeklifSepetHesapla !== undefined
            ? stateVars.TeklifSepetHesapla?.length > 0
              ? stateVars.TeklifSepetHesapla[0].genelToplam
              : null
            : this.state.TeklifSepetHesapla?.length > 0
            ? this.state.TeklifSepetHesapla[0].genelToplam
            : null
        ),
        "number"
      ),
      KullaniciID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      ),
      ParaBirimi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      ),
      TeklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifNumarasi !== undefined
            ? stateVars.GetTeklifNumarasi?.length > 0
              ? stateVars.GetTeklifNumarasi[0].yeniTeklifNumarasi
              : null
            : this.state.GetTeklifNumarasi?.length > 0
            ? this.state.GetTeklifNumarasi[0].yeniTeklifNumarasi
            : null
        ),
        "string"
      ),
      TalepNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_655780_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PlasiyerKodu_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].plasiyeR_KODU
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].plasiyeR_KODU
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_838301_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetTeklifNumarasi = result?.data.getTeklifNumarasi;
    stateVars.InsertTeklifMas = result?.data.insertTeklifMas;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_838301_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturComponent_838301_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BirimFiyat_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.birimFiyat),
        "number"
      ),
      Miktar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.miktar),
        "number"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifNumarasi !== undefined
            ? stateVars.GetTeklifNumarasi?.length > 0
              ? stateVars.GetTeklifNumarasi[0].yeniTeklifNumarasi
              : null
            : this.state.GetTeklifNumarasi?.length > 0
            ? this.state.GetTeklifNumarasi[0].yeniTeklifNumarasi
            : null
        ),
        "string"
      ),
      StokAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.stokAdi),
        "string"
      ),
      StokKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.stokKodu),
        "string"
      ),
      MusteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.musteriMarka),
        "string"
      ),
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.firmaKodu),
        "string"
      ),
      KdvOrani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.kdvOrani),
        "number"
      ),
      ExcelKod_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.excelKod),
        "string"
      ),
      ExcelNot1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.excelNot1),
        "string"
      ),
      ExcelNot2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.excelNot2),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_838301_onClick_foreach1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InsertTeklifTra = result?.data.insertTeklifTra;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TeklifOlusturComponent_838301_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.GetTeklifSepeti)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.GetTeklifSepeti
      )) {
        this.ForEach3 = item;
        await this.TeklifOlusturComponent_838301_onClick_foreach1();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_838301_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeklifOlusturComponent_838301_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirmaKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_KOD
            : null
        ),
        "string"
      ),
      musteriMarka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_595843_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Mesaj_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_451268_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      KullaniciAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      isPlasiyer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].isPlasiyer
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].isPlasiyer
            : null
        ),
        "boolean"
      ),
      TeklifNumarasi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifNumarasi !== undefined
            ? stateVars.GetTeklifNumarasi?.length > 0
              ? stateVars.GetTeklifNumarasi[0].yeniTeklifNumarasi
              : null
            : this.state.GetTeklifNumarasi?.length > 0
            ? this.state.GetTeklifNumarasi[0].yeniTeklifNumarasi
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_838301_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.TeklifSonrasiSepetSil = result?.data.teklifSonrasiSepetSil;
    stateVars.InsertTeklifGorusmeleri = result?.data.insertTeklifGorusmeleri;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_838301_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  TeklifOlusturComponent_838301_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.TeklifOlusturPageInit();

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "a87d7f38_8bfa_3640_c6f8_d284846b4160_notify",
        this.defaultML,
        "Teklif Başarıyla Oluşturuldu. Teklif Durumları Sayfasından Teklif Sürecini Kontrol Edebilirsiniz."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      10,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.TeklifOlusturComponent_838301_onClick4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  TeklifOlusturComponent_838301_onClick_if4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      templateId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "2e892919-e014-48bb-a2f6-71a9782e624f",
          "string"
        ),
        "string"
      ),
      receivers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariPlasiyerBilgileri !== undefined
            ? stateVars.GetCariPlasiyerBilgileri?.length > 0
              ? stateVars.GetCariPlasiyerBilgileri[0].kullaniciKodu
              : null
            : this.state.GetCariPlasiyerBilgileri?.length > 0
            ? this.state.GetCariPlasiyerBilgileri[0].kullaniciKodu
            : null
        ),
        "string"
      ),
      subject_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Yeni Teklif", "string"),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      Tarih_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("10.01.2025", "string"),
        "string"
      ),
      TeklifNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetTeklifNumarasi !== undefined
            ? stateVars.GetTeklifNumarasi?.length > 0
              ? stateVars.GetTeklifNumarasi[0].yeniTeklifNumarasi
              : null
            : this.state.GetTeklifNumarasi?.length > 0
            ? this.state.GetTeklifNumarasi[0].yeniTeklifNumarasi
            : null
        ),
        "string"
      ),
      KullaniciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].adSoyad
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].adSoyad
            : null
        ),
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_ISIM
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_ISIM
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "TeklifOlustur/TeklifOlusturComponent_838301_onClick_if4",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  TeklifOlusturComponent_838301_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.toString(this, this.state.ReadFromSessionStorage),
        true
      )
    ) {
      isErrorOccurred = await this.TeklifOlusturComponent_838301_onClick_if4();
      if (isErrorOccurred) return true;
    } else {
    }

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/teklifdurumlari") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifOlustur",
      "TeklifDurumlari",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  TeklifOlusturComponent_25646_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "cariKod",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[
                  stateVars.GetCariBilgileri.length - 1
                ].carI_KOD
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[
                this.state.GetCariBilgileri.length - 1
              ].carI_KOD
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "GenelToplam",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.TeklifSepetHesapla !== undefined
            ? stateVars.TeklifSepetHesapla?.length > 0
              ? stateVars.TeklifSepetHesapla[0].genelToplam
              : null
            : this.state.TeklifSepetHesapla?.length > 0
            ? this.state.TeklifSepetHesapla[0].genelToplam
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "PlasiyerKodu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].plasiyeR_KODU
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].plasiyeR_KODU
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "TalepNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_655780_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "paraBirimi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].parabirimi
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].parabirimi
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "KulID",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].id
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].id
            : null
        ),
        "number"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "MusteriMarka",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_595843_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "teklifolustur_451268_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "MusteriAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetCariBilgileri !== undefined
            ? stateVars.GetCariBilgileri?.length > 0
              ? stateVars.GetCariBilgileri[0].carI_ISIM
              : null
            : this.state.GetCariBilgileri?.length > 0
            ? this.state.GetCariBilgileri[0].carI_ISIM
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KullaniciSecme",
      "PlasiyerAdi",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetKullanici !== undefined
            ? stateVars.GetKullanici?.length > 0
              ? stateVars.GetKullanici[0].adSoyad
              : null
            : this.state.GetKullanici?.length > 0
            ? this.state.GetKullanici[0].adSoyad
            : null
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "TeklifOlustur",
      "KullaniciSecme",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "200056",
      null,
      null,
      "true",
      "650px",
      "35vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, , 288727, , 986362, , 200056] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.TeklifOlusturPageInit();
    }
  }
}
